"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullPageModal = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var react_feather_1 = require("react-feather");
var BaseModal_1 = require("./BaseModal");
var theme_1 = require("./theme");
/**
 * Modal spanning the full page width.
 * @param {Function} hideModal - Required. Function to be called when exiting the modal
 * @param {boolean} isOpen - Required. Describes if the modal should be shown or not
 * @param {boolean=} showIcon - Controls visibility of the close icon
 * @param {string=} margin - Override the default margin style
 * @param {Object=} style - Custom style object used in react-modal
 * @param {Object=} style.content - Custom content styles
 * @param {Object=} style.overlay - Custom overlay styles
 */
var FullPageModal = function (_a) {
    var isOpen = _a.isOpen, hideModal = _a.hideModal, _b = _a.showIcon, showIcon = _b === void 0 ? true : _b, children = _a.children, _c = _a.margin, margin = _c === void 0 ? "".concat(theme_1.theme.space.large, " ").concat(theme_1.theme.space.medium) : _c, _d = _a.style, style = _d === void 0 ? {} : _d;
    return (react_1.default.createElement(BaseModal_1.BaseModal, { isOpen: isOpen, hideModal: hideModal, style: __assign(__assign({}, style), { overlay: __assign({ zIndex: 2 }, style.overlay), content: __assign({ width: "100%", inset: 0 }, style.content) }) },
        showIcon && (react_1.default.createElement(StyledCloseIcon, { size: 18, stroke: theme_1.theme.colors.gray600, onClick: hideModal })),
        react_1.default.createElement(Wrapper, { margin: margin }, children)));
};
exports.FullPageModal = FullPageModal;
var StyledCloseIcon = (0, styled_1.default)(react_feather_1.X)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  right: 20px;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: ", ";\n  right: 20px;\n  cursor: pointer;\n"])), theme_1.theme.space.medium);
var Wrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  margin: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])), function (_a) {
    var margin = _a.margin;
    return margin;
});
var templateObject_1, templateObject_2;
